import React, { useContext } from "react";
import MintViewModel from "./viewModel";
import Button from "../../components/Button";
import Card from "../../components/Card";
import logo from "../../asset/logo.png";
import "./style.css";
import Processing from "../../components/Status/Processing";
import Failed from "../../components/Status/Failed";
import { Toast, ToastContainer } from "react-bootstrap";
import ErrorList from "../../components/ErrorList";

const Mint = () => {
  const {
    onConfirm,
    isLoading,
    error,
    alert,
    showAlert,
    onCloseAlert,
    address,
    isChainValid,
    requestAccounts,
  } = useContext(MintViewModel.Context);
  return (
    <main id={"mint"} className={"wraps"}>
      <ToastContainer position="top-end" className="p-3">
        {showAlert && (
          <Toast onClose={() => onCloseAlert()} delay={5000} autohide>
            <Toast.Header>
              <strong className="me-auto">{alert.title}</strong>
            </Toast.Header>
            <Toast.Body>{alert.message}</Toast.Body>
          </Toast>
        )}
      </ToastContainer>
      <div className={"logo_imgs"}>
        <img src={logo} alt="QonBay.io" />
      </div>
      <Card>
        <h2>Mint</h2>
        {!address && (
          <Button
            variant={"secondary"}
            onClick={() => requestAccounts()}
            disabled={!isChainValid}
            style={{ marginBottom: "1rem" }}
          >
            Connect Wallet
          </Button>
        )}
        {isLoading && <Processing />}
        {!isLoading && error && <Failed />}
        {!isLoading && error && <ErrorList />}
        <Button
          onClick={() => onConfirm()}
          disabled={isLoading || !address || !isChainValid}
          className={"default-btn confirm-btn"}
        >
          {error ? "Retry" : "Confirm"}
        </Button>
      </Card>
    </main>
  );
};

export default MintViewModel.withProvider(Mint);
